var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLock = function SvgLock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 9,
    width: 16,
    height: 12,
    rx: 3,
    stroke: "#232750",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 8V7a4 4 0 0 0-8 0v1",
    stroke: "#232750",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5 15.732a2 2 0 0 0-1-3.732 2 2 0 0 0-1 3.732V17a1 1 0 1 0 2 0v-1.268Z",
    fill: "#232750"
  })));
};
export { SvgLock as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjUiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNSAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iNC41IiB5PSI5IiB3aWR0aD0iMTYiIGhlaWdodD0iMTIiIHJ4PSIzIiBzdHJva2U9IiMyMzI3NTAiIHN0cm9rZS13aWR0aD0iMiIvPgo8cGF0aCBkPSJNMTYuNSA4VjdDMTYuNSA0Ljc5MDg2IDE0LjcwOTEgMyAxMi41IDNWM0MxMC4yOTA5IDMgOC41IDQuNzkwODYgOC41IDdWOCIgc3Ryb2tlPSIjMjMyNzUwIiBzdHJva2Utd2lkdGg9IjIiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMy41IDE1LjczMjRDMTQuMDk3OCAxNS4zODY2IDE0LjUgMTQuNzQwMyAxNC41IDE0QzE0LjUgMTIuODk1NCAxMy42MDQ2IDEyIDEyLjUgMTJDMTEuMzk1NCAxMiAxMC41IDEyLjg5NTQgMTAuNSAxNEMxMC41IDE0Ljc0MDMgMTAuOTAyMiAxNS4zODY2IDExLjUgMTUuNzMyNFYxN0MxMS41IDE3LjU1MjMgMTEuOTQ3NyAxOCAxMi41IDE4QzEzLjA1MjMgMTggMTMuNSAxNy41NTIzIDEzLjUgMTdWMTUuNzMyNFoiIGZpbGw9IiMyMzI3NTAiLz4KPC9zdmc+Cg==";